import React, { useState } from 'react'
import UploadPartsList from './uploadpartslist';
import { IpropsContainer } from './uploadpartslistinterface';

function UploadPartsListContainer(props: IpropsContainer)
{
    return (<UploadPartsList {...props} />)
}

export default UploadPartsListContainer